import { ApiResponse } from '../types';
import { LoginRecordQueryParams, LoginRecordResponse } from '../types/loginRecord';
import { http, buildUrl } from './base';
import { API_CONFIG, buildApiUrl } from '../config/api';

/**
 * 登录记录相关 API 服务
 */
export class LoginRecordService {
  /**
   * 获取登录记录列表
   * @param params 查询参数
   */
  static async getLoginRecords(params?: LoginRecordQueryParams): Promise<ApiResponse<LoginRecordResponse>> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.LOGIN_RECORD.LIST);
    return http.get(url, params);
  }

  /**
   * 踢下线（使指定登录记录的令牌失效）
   * @param recordId 登录记录ID
   */
  static async kickout(recordId: number): Promise<ApiResponse<void>> {
    const url = buildApiUrl(API_CONFIG.ENDPOINTS.LOGIN_RECORD.KICKOUT, { id: String(recordId) });
    return http.post(url);
  }
}

export default LoginRecordService;
